import React from "react";
import { Modal, Form, Radio, Image, message } from 'antd'
import {  dispatchAsync } from 'friday-async'
import { get } from 'lodash'
import { useApiSelector } from 'src/hooks'
import config from '../../config'

const ModalStatus = (props) => {

    const apis = useApiSelector()

    const [form] = Form.useForm();

    const { visible, record, onCancel } = props;

    const img = config.imgHost + get(record, 'assest[0]')

    console.log(img)

    const onFinish = async (values) => {
        const { error } = await dispatchAsync(apis.analysis.audit({
            id: record._id,
            leadsBizCode: values.leadsBizCode,
        }))
        if (error) return message.error('操作失败')
        props.onFinishAndRevalidate()
        message.success('操作成功')
        onCancel()
    }

    return (
        <Form 
            form={form}
            onFinish={onFinish}
            labelCol={{span: 5}}
        >
            <Modal
                title='合同审核'
                open={visible}
                onCancel={onCancel}
                onOk={form.submit}
                bodyStyle={{
                    paddingTop: 40
                }}
            >
                <Form.Item label='合同内容'  >
                    <Image src={img} style={{width: 180, }} />
                </Form.Item>
                <Form.Item label='审核意见' name='leadsBizCode' required rules={[{required: true, message: '请选择审核意见'}]}>
                    <Radio.Group >
                        <Radio value='success_finished'>通过</Radio>
                        <Radio value='fail_finished'>拒绝</Radio>
                    </Radio.Group>
                </Form.Item>
            </Modal>
        </Form>
    )
}


export default ModalStatus;